import { useState } from 'react'
import { X } from 'lucide-react'
import api from '../services/api'
import { T } from '../theme'

export default function ChangePasswordModal({ onClose }) {
  const [currentPwd, setCurrentPwd]   = useState('')
  const [newPwd,     setNewPwd]       = useState('')
  const [confirmPwd, setConfirmPwd]   = useState('')
  const [error,      setError]        = useState('')
  const [loading,    setLoading]      = useState(false)
  const [success,    setSuccess]      = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')

    if (newPwd.length < 8) {
      setError('Le nouveau mot de passe doit faire 8 caractères minimum.')
      return
    }
    if (newPwd !== confirmPwd) {
      setError('Les deux nouveaux mots de passe ne correspondent pas.')
      return
    }

    setLoading(true)
    try {
      await api.post('/account/change-password', {
        current_password: currentPwd,
        new_password:     newPwd,
      })
      setSuccess(true)
      setTimeout(onClose, 1800)
    } catch (err) {
      const detail = err?.response?.data?.detail
      setError(detail || 'Erreur lors du changement de mot de passe.')
    } finally {
      setLoading(false)
    }
  }

  const inputS = {
    width: '100%', boxSizing: 'border-box',
    background: 'rgba(255,255,255,0.04)',
    border: `1px solid ${T.ruleDark}`,
    padding: '11px 14px', color: T.ink,
    fontFamily: T.mono, fontSize: 13,
    outline: 'none', borderRadius: 0,
    transition: 'border-color .15s',
  }
  const labelS = {
    fontFamily: T.mono, fontSize: 9,
    letterSpacing: '.14em', textTransform: 'uppercase',
    color: T.muted2, display: 'block', marginBottom: 6,
  }

  return (
    <div
      onClick={() => { if (!loading) onClose() }}
      style={{ position: 'fixed', inset: 0, zIndex: 1001, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: T.surface, border: `1px solid ${T.ruleDark}`, borderTop: `2px solid ${T.gold}`, maxWidth: 440, width: '100%', padding: 28, boxShadow: '0 16px 48px rgba(0,0,0,0.4)' }}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <div style={{ fontFamily: T.mono, fontSize: 9, letterSpacing: '.18em', textTransform: 'uppercase', color: T.gold, marginBottom: 4 }}>
              Sécurité
            </div>
            <h2 style={{ fontFamily: T.display, fontSize: 20, fontWeight: 800, color: T.ink, textTransform: 'uppercase', letterSpacing: '.02em', margin: 0 }}>
              Mot de passe
            </h2>
          </div>
          <button onClick={onClose} disabled={loading}
            style={{ background: 'none', border: 'none', cursor: loading ? 'default' : 'pointer', color: T.muted, padding: 4 }}>
            <X size={18} />
          </button>
        </div>

        {success ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontFamily: T.mono, fontSize: 13, fontWeight: 600, color: T.green }}>
              Mot de passe modifié.
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={labelS}>Mot de passe actuel</label>
              <input
                type="password" value={currentPwd} autoComplete="current-password" required
                onChange={e => setCurrentPwd(e.target.value)}
                style={inputS}
              />
            </div>
            <div>
              <label style={labelS}>Nouveau mot de passe</label>
              <input
                type="password" value={newPwd} autoComplete="new-password" required
                onChange={e => setNewPwd(e.target.value)}
                style={inputS}
              />
            </div>
            <div>
              <label style={labelS}>Confirmer le nouveau mot de passe</label>
              <input
                type="password" value={confirmPwd} autoComplete="new-password" required
                onChange={e => setConfirmPwd(e.target.value)}
                style={inputS}
              />
            </div>

            {error && (
              <p style={{ fontFamily: T.mono, fontSize: 11, color: T.red, margin: 0 }}>{error}</p>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 4 }}>
              <button type="button" onClick={onClose} disabled={loading}
                style={{ fontFamily: T.mono, fontSize: 11, fontWeight: 600, letterSpacing: '.06em', textTransform: 'uppercase', color: T.muted, background: 'transparent', border: `1px solid ${T.rule}`, padding: '9px 18px', cursor: loading ? 'default' : 'pointer' }}>
                Annuler
              </button>
              <button type="submit" disabled={loading || !currentPwd || !newPwd || !confirmPwd}
                style={{ fontFamily: T.mono, fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', background: T.gold, color: '#fff', border: 'none', padding: '9px 20px', cursor: loading || !currentPwd || !newPwd || !confirmPwd ? 'default' : 'pointer', opacity: loading || !currentPwd || !newPwd || !confirmPwd ? 0.55 : 1, transition: 'opacity .15s' }}>
                {loading ? 'Enregistrement...' : 'Modifier'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
